import React from 'react';
import { Box, Stack, Typography, keyframes } from '@mui/material';
import { Loader2 } from 'lucide-react';

const pulseRing = keyframes`
  0% {
    box-shadow: 0 0 0 0 rgba(32, 174, 220, 0.32);
  }
  70% {
    box-shadow: 0 0 0 8px rgba(32, 174, 220, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(32, 174, 220, 0);
  }
`;

export const nutritionItemAddingColumnSx = {
  position: 'relative' as const,
  bgcolor: '#EAF7FC !important',
  outline: '1.5px solid rgba(32, 174, 220, 0.45)',
  outlineOffset: '-1px',
  boxShadow: 'inset 0 0 0 1px rgba(32, 174, 220, 0.08)',
};

type NutritionItemAddingPanelProps = {
  title?: string;
  subtitle?: string;
};

export const NutritionItemAddingPanel: React.FC<NutritionItemAddingPanelProps> = ({
  title = 'Updating nutrition values',
  subtitle = 'Updating nutrition values...',
}) => (
  <Stack
    spacing={1.5}
    alignItems="center"
    sx={{
      px: 3,
      py: 2.75,
      borderRadius: '14px',
      bgcolor: '#ffffff',
      border: '1px solid #D5EEF7',
      boxShadow: '0 10px 28px rgba(32, 174, 220, 0.14)',
      minWidth: 220,
    }}
  >
    <Box
      sx={{
        width: 48,
        height: 48,
        borderRadius: '14px',
        bgcolor: '#EAF7FC',
        display: 'grid',
        placeItems: 'center',
        animation: `${pulseRing} 1.8s ease-out infinite`,
      }}
    >
      <Loader2 className="h-5 w-5 animate-spin text-[#20AEDC]" aria-hidden />
    </Box>
    <Stack spacing={0.35} alignItems="center" sx={{ textAlign: 'center' }}>
      <Typography
        sx={{
          fontFamily: 'Inter, sans-serif',
          fontSize: '0.92rem',
          fontWeight: 700,
          color: '#1F2937',
          lineHeight: 1.3,
        }}
      >
        {title}
      </Typography>
      <Typography
        sx={{
          fontFamily: 'Inter, sans-serif',
          fontSize: '0.76rem',
          color: '#667085',
          lineHeight: 1.4,
        }}
      >
        {subtitle}
      </Typography>
    </Stack>
  </Stack>
);
